import {i18n} from '@yourcoach/i18n';

import type {EditionApiModel} from '../../../api/program/edition';

export interface ProgramType {
  id: string;
  toString: () => string;
}

interface ProgramTypeEnum {
  GROUP: ProgramType;
  INDIVIDUAL: ProgramType;
}

export const ProgramTypeEnum: ProgramTypeEnum = {
  GROUP: {
    id: 'group',
  },
  INDIVIDUAL: {
    id: 'individual',
  },
};

export const getProgramType = (edition: EditionApiModel) =>
  edition.group_size > 1 ? ProgramTypeEnum.GROUP : ProgramTypeEnum.INDIVIDUAL;

Object.keys(ProgramTypeEnum).forEach(key => {
  const type: ProgramType = ProgramTypeEnum[key];

  type.toString = () =>
    /**
     * @i18n_parser
     * t('shared:program.type.group')
     * t('shared:program.type.individual')
     */
    i18n.t(`shared:program.type.${type.id}`);
});
